import { FC } from 'react'
import { observer } from 'mobx-react'
import { IJobBase } from '@/types'
import { CompanyLogoAndName } from '@/componentsV2/molecules/CompanyLogoAndName'
import { getDateTimeFromUtc, useStores } from '@/utils'
import { JobSaveAndApplyGroup } from '@/componentsV2/molecules/JobSaveAndApplyGroup'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobApplyGroupTop: FC<Props> = observer(({ job }) => {
  const { viewer } = useStores()
  const date = `Posted ${getDateTimeFromUtc(job.updatedAt, 'DD MMM YYYY')}`

  return (
    <div className='container'>
      <div className={styles.container}>
        <div className={styles.company}>
          <CompanyLogoAndName company={job?.company} size='xl' date={date} />
        </div>
        {viewer?.isSignedIn && (
          <div className={styles.buttons}>
            <JobSaveAndApplyGroup job={job} />
          </div>
        )}
      </div>
    </div>
  )
})
